import { useRouteError, isRouteErrorResponse, Link } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import { ErrorOutline as ErrorOutlineIcon } from '@mui/icons-material';

export default function RouteErrorBoundary()
{
    const error = useRouteError();

    let title = 'Ein unerwarteter Fehler ist aufgetreten';
    let message = 'Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.';
    let status = null;

    if(isRouteErrorResponse(error))
    {
        status = error.status;

        if(error.status === 404)
        {
            title = 'Seite nicht gefunden';
            message = 'Die angeforderte Seite existiert nicht.';
        }
        else if(error.status === 403)
        {
            title = 'Zugriff verweigert';
            message = 'Sie haben keine Berechtigung, diese Seite aufzurufen.';
        }
        else
        {
            message = error.statusText || message;
        }
    }
    else if(error instanceof Error)
    {
        message = error.message;
    }

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '60vh',
                gap: 2,
                textAlign: 'center',
                p: 4,
            }}
        >
            <ErrorOutlineIcon sx={{ fontSize: 64, color: 'error.main' }} />
            {status && (
                <Typography variant="h3" component="p" color="text.secondary">
                    {status}
                </Typography>
            )}
            <Typography variant="h5" component="h1">
                {title}
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ maxWidth: '40rem' }}>
                {message}
            </Typography>
            <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
                <Button variant="outlined" onClick={() => window.location.reload()}>
                    Seite neu laden
                </Button>
                <Button variant="contained" component={Link} to="/home">
                    Zur Startseite
                </Button>
            </Box>
        </Box>
    );
}
